<template>
    <div class='data'>
        <label class="lable">{{lables}}</label>
        <el-date-picker size="mini"
            v-model="startTimes"
            :type="isDatetime"
            :value-format="valueFormat"
            placeholder="开始时间"
            :clearable='false'
            :picker-options='isAstrict?startOptions:startOptions1'
            @change="getStartOptions"
            style="width:200px;"
            >
        </el-date-picker>
            -
        <el-date-picker size="mini"
            v-model="endTimes"
            :type="isDatetime"
            :value-format="valueFormat"
            placeholder="结束时间"
            :clearable='false'
            :picker-options='isAstrict?endOptions:endOptions1'
            @change="getEndOptions"
            style="width:200px;"
            >
        </el-date-picker>
    </div>
</template>
<script>
import {timefilters} from "@/common/times";
export default {
  name: "daterange",
  props:{
    startTime:{
      type: String,
      default: ()=>{ return '' }
    },
    endTime:{
      type: String,
      default: ()=>{ return '' }
    },
    lable:{
        type: String,
        default: ()=>{ return '起止时间' }
    },
    //时间定位
    identifying:{
        type: String,
        default: ()=>{ return '' }
    },
    //时间类型（仅支持datetime/date）
    isDatetime:{
        type: String,
        default: ()=>{ return 'date' }
    },
    isAstrict:{
        type: Boolean,
        default: ()=>{ return true}
    },
  },
  data() {
    return {
        startTimes:this.startTime,
        endTimes:this.endTime,
        lables:this.lable,
        identifyings:this.identifying,
        valueFormat:this.isDatetime=='date'?'yyyy-MM-dd':'yyyy-MM-dd HH:mm:ss',
        startOptions:{
            disabledDate(time) {
                return time.getTime() > Date.now()
            },
        },
        endOptions:{
            disabledDate(time) {
                return time.getTime() > Date.now()
            },
        },
        startOptions1:{},
        endOptions1:{},
    }
  },
  mounted(){
    // this.initHandle()
  },
  methods: {
    // 初始化值
    initHandle(){
        if(!this.endTimes||!this.startTimes){
            var  a =timefilters(new Date()).slice(0,7)
            this.endTimes =timefilters(new Date(new Date(a)-1000 * 60 * 60 * 24));
            this.startTimes = timefilters(new Date(a).setMonth(new Date(a).getMonth() - 1));
        }
    },
    getStartOptions(e){
        if(this.isAstrict){
            this.endOptions={
                disabledDate(time) {
                    return time.getTime() > Date.now() || time.getTime() < new Date(e).getTime()- 8.64e7+1
                },
            }
        }else{
            this.endOptions1={
                disabledDate(time) {
                    return time.getTime() < new Date(e).getTime()- 8.64e7+1
                },
            }
        }

      },
      getEndOptions(e){
        if(this.isAstrict){
            this.startOptions={
                disabledDate(time) {
                    return time.getTime() > Date.now() || time.getTime() > new Date(e).getTime()
                },
            }
        }else{
            this.startOptions1={
                disabledDate(time) {
                    return time.getTime() > new Date(e).getTime()
                },
            }
        }
      }
  },
  watch: {
    startTime(val) {
        this.startTimes=val
        if(this.isDatetime=='datetime'){
            var startTime=new Date(this.startTimes)
            var endTimes=new Date(this.endTimes)
            if(startTime>endTimes){
                this.endTimes=this.startTimes
            }
        }
    },
    endTime(val) {
        this.endTimes=val
        if(this.isDatetime=='datetime'){
            var startTime=new Date(this.startTimes)
            var endTimes=new Date(this.endTimes)
            if(startTime>endTimes){
                this.startTimes=this.endTimes
            }
        }
    },
    startTimes(val){
        this.$emit("dataChange",[val,this.endTimes],this.identifyings);
    },
    endTimes(val) {
        this.$emit("dataChange",[this.startTimes,val],this.identifyings);
    },
  },
};
</script>
<style scoped>
    .data{
        display: inline;
    }
    .demo-form-inline{
        display: inline;
    }
    .lable{
        float: none;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
        font-size: 12px;
        color: #606266;
        padding: 0 12px 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
</style>
